<h2 mat-dialog-title>{{ 'dataManagement.import.titleExcelImport' | transloco }}</h2>

<mat-dialog-content style="min-width: 500px; min-height: 250px">
  <input type="file" accept=".xlsx" (change)="openExcelFile($event)" #hiddenFileInput onclick="value=null" style="display: none" />

  <mat-card class="upload-card">
    <mat-card-content>
      <div class="upload-row">
        <button *ngIf="!excelFile" mat-raised-button (click)="hiddenFileInput.click()" color="primary" type="button">
          <mat-icon>upload</mat-icon>
          {{ 'dataManagement.manageOrganizations.bulkUpload.loadExcelFileButton' | transloco }}
        </button>

        <div *ngIf="excelFile" class="file-uploaded">
          <mat-icon color="primary">description</mat-icon>
          <span>{{ excelFile.name }}</span>
          <button mat-icon-button type="button" (click)="excelFile = null">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="upload-note">
        <mat-icon color="primary">info</mat-icon>
        <small class="mat-caption">
          {{ 'excel.uploadNote' | transloco }}
        </small>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card class="upload-card">
    <mat-card-content>
      <div class="upload-row">
        <button *ngIf="!selectedFolder" mat-raised-button (click)="openFolderSelection()" color="primary" type="button">
          <mat-icon>folder</mat-icon>
          {{ 'dataManagement.directory.dialog.addEditFolder.moveTitle' | transloco }}
        </button>

        <div *ngIf="selectedFolder" class="file-uploaded">
          <mat-icon color="primary">folder</mat-icon>
          <span>{{ selectedFolder.name }}</span>
          <button mat-icon-button type="button" (click)="selectedFolder = null">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</mat-dialog-content>

<mat-dialog-actions align="end" style="padding-bottom: 20px; padding-right: 20px">
  <button mat-dialog-close mat-raised-button type="button" [disabled]="spinnerActive">
    {{ 'dataManagement.manageOrganizations.bulkUpload.closeButton' | transloco }}
  </button>
  <button mat-raised-button type="submit" color="primary" (click)="uploadCreateUnit()" [disabled]="spinnerActive || excelFile == null || selectedFolder == null">
    <span class="import-button-content">
      <span>{{ 'common.buttons.import' | transloco }}</span>
      <mat-spinner *ngIf="spinnerActive" diameter="18"></mat-spinner>
    </span>
  </button>
</mat-dialog-actions>
